import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { AssertByTypename } from '@/helpers/graphql-model-helper';
import type { SnowplowSportContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { SponsoredAdSportFragmentFragment } from '@/pages/graphql/fragments/SponsoredAdSport.fragment';

import { ImpressionTrackingEvents } from '@/enums/events';
import { mrcObservableOptions } from '@/helpers/composables/useBatchImpressionTracking';

import SponsoredRecommendationSportView from '@/components/sponsored-recommendations/SponsoredRecommendationSportsView.vue';

type SingleStepSportEvent = AssertByTypename<typeof props.sponsoredAd.campaign.node, 'SingleStepSportEvent'>;

export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationSports',
  props: {
    sponsoredAd: null,
    sportContext: null
  },
  setup(__props: any) {

const props = __props as {
	sponsoredAd: SponsoredAdSportFragmentFragment;
	sportContext: SnowplowSportContext;
}



// DAZN
const offer = { package: { packageId: 695 } };

const impressionTrackingLabel = computed(() => {
	const node = props.sponsoredAd.campaign.node as SingleStepSportEvent;
	return `${node?.id}_${offer?.package.packageId}`;
});

return { __sfc: true,props, offer, impressionTrackingLabel, ImpressionTrackingEvents, mrcObservableOptions, SponsoredRecommendationSportView }
}

})